<script lang="ts" setup>
    import { EventName } from '@/constants';
    import i18n from '@/plugins/i18n';
    import eventBus from '@/services/eventBus';
    import { userService } from '@/services/userService';
    import { languageDictionary, useTimeZoneDictionary } from '@/stores';
    import { useUserStore } from '@/stores/user';

    const { t, locale } = useI18n();

    const userStore = useUserStore();

    const timeZoneDictionary = useTimeZoneDictionary();

    const setLocale = (lang: string): void => {
        if (!lang) return;

        locale.value = lang;
        localStorage.setItem('locale', lang);
        eventBus.emit(EventName.LanguageChanged, lang);
    };

    const setTimeZone = async (value: string): Promise<void> => {
        if (!value) return;

        if (userStore.isLoggedIn()) {
            await userService.changeTimeZone(value);
            userStore.timeZone = value;
        } else {
            userStore.timeZone = value;
            //todo uncomment and fix it
            //localStorage.setItem('user', JSON.stringify(user.value));
        }
    };

    onMounted((): void => {
        console.log('Component app-menuAccountChangeLocaleAndTimeZone mounted.');
    });
</script>
<template>
    <div class="px-3 pb-3 pt-1">
        <v-row density="comfortable">
            <v-col cols="6">
                <v-autocomplete
                    autocomplete="off"
                    density="compact"
                    variant="outlined"
                    hide-details
                    class="filter"
                    color="grey"
                    :label="t('menu.language')"
                    :items="languageDictionary.items"
                    item-value="id"
                    item-title="name"
                    :model-value="i18n.global.locale.value"
                    @update:model-value="setLocale"
                />
            </v-col>
            <v-col cols="6">
                <v-autocomplete
                    autocomplete="off"
                    density="compact"
                    variant="outlined"
                    hide-details
                    class="filter"
                    color="grey"
                    :label="t('menu.timeZone')"
                    :items="timeZoneDictionary.items"
                    item-value="code"
                    item-title="name"
                    :model-value="userStore.timeZone"
                    @update:model-value="setTimeZone"
                />
            </v-col>
        </v-row>
    </div>
</template>
